import { GetExperienceResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { experienceKeys } from "../queryKeys";

export const getSourceExperience = async (
  experienceId: string
): Promise<GetExperienceResponseBodyType | null> => {
  try {
    const resp = await api.get<GetExperienceResponseBodyType>(
      `/v2/experiences/${experienceId}`
    );
    // Return null if the experience is deleted
    if (resp.data?.experience?.isDeleted) {
      return null;
    }
    return resp.data;
  } catch (error: any) {
    // Return null on 404 (experience not found) - this is expected for deleted source experiences
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const useGetSourceExperience = (
  experienceId: string | undefined,
  options?: QueryOptions<GetExperienceResponseBodyType | null, Error>
) => {
  const query = useQuery({
    ...options,
    queryKey: experienceKeys.one(experienceId!),
    queryFn: async () => getSourceExperience(experienceId!),
    enabled: Boolean(experienceId),
  });

  return query;
};
